__turbopack_context__.v({
  "container": "bgB-GG_container",
  "dark": "bgB-GG_dark",
  "main": "bgB-GG_main",
  "modalOpen": "bgB-GG_modalOpen",
});
